/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentsListAliases {
  APPOINTMENTS_FETCH = 'appointments-fetch',
  AUTOCOMPLETE_CATEGORIES = 'autocomplete-categories',
  AUTOCOMPLETE_EXAMS = 'autocomplete-exams',
  AUTOCOMPLETE_PHYSICIAN = 'autocomplete-physician',
  AUTOCOMPLETE_SPECIALITYS = 'autocomplete-specialitys',
  AVATAR_0 = 'avatar-0',
  BUTTON_ADD_APPOINTMENT = 'button-add-appointment',
  CARD_APPOINTMENTS_DECK_APPOINTMENTS_APPOINTMENTS_LIST = 'card-appointments-deck-appointments-appointments-list',
  CARD_APPOINTMENTS_WAITING_LIST = 'card-appointments-waiting-list',
  CHECKBOX_CANCELLED = 'checkbox-cancelled',
  CONTEXTUAL_BAR_APPOINTMENTS_APPOINTMENTS_LIST = 'contextual-bar-appointments-appointments-list',
  DATE_FILTER_FIELD = 'date-filter-field',
  DECK_APPOINTMENTS = 'deck-appointments',
  DECK_WAITING_LIST = 'deck-waiting-list',
  FETCH_EXAMS = 'fetch-exams',
  FETCH_PHYSICIAN_INFO = 'fetch-physician-info',
  FETCH_WAITING_LIST = 'fetch-waiting-list',
  FIELD_CANCELLED = 'field-cancelled',
  FIELD_EXAMS = 'field-exams',
  FIELD_FILTER_CATEGORIES = 'field-filter-categories',
  FIELD_FILTER_PHYSICIAN = 'field-filter-physician',
  FIELD_SPECIALITYS = 'field-specialitys',
  FILTER_APPOINTMENTS_LIST = 'filter-appointments-list',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  FROM_DATE_FIELD = 'from-date-field',
  LAYOUT_APPOINTMENTS = 'layout-appointments',
  LAYOUT_APPOINTMENTS_CONTENT_APPOINTMENTS_APPOINTMENTS_LIST = 'layout-appointments-content-appointments-appointments-list',
  LAYOUT_CONTENT = 'layout-content',
  MAPPER_CATEGORIES = 'mapper-categories',
  MAPPER_EXAMS = 'mapper-exams',
  MAPPER_PHYSICIAN_INFO = 'mapper-physician-info',
  MAPPER_SPECIALITYS = 'mapper-specialitys',
  MAPPER_WAITING_LIST = 'mapper-waiting-list',
  PANEL_DECK_APPOINTMENTS = 'panel-deck-appointments',
  PANEL_DECK_ITEMS = 'panel-deck-items',
  PANEL_DECK_WAITING_LIST = 'panel-deck-waiting-list',
  PANEL_GENERAL = 'panel-general',
  TEXT_EXAMS = 'text-exams',
  TEXT_SPECIALITYS = 'text-specialitys',
  TEXT_TYPE = 'text-type',
}
export { AppointmentsListAliases };
